var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "mt-4 mb-5 text-left" }, [
      _c("p", { staticClass: "text-lg mb-1" }, [
        _vm._v("¡Gracias por afiliarte!"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text-sm text-muted" }, [
        _c("b", [_vm._v("Paso " + _vm._s(_vm.step) + ":")]),
        _vm._v(
          " " +
            _vm._s(
              _vm.step == 1
                ? "Completa tu perfil."
                : _vm.step == 2
                ? "Ingrese al menos 1 número de teléfono."
                : ""
            )
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.COMPLETE()
          },
        },
      },
      [
        _vm.step == 1
          ? _c("div", { staticClass: "row" }, [
              _vm.data.account_type == 2
                ? _c("div", { staticClass: "col-12 px-0" }, [
                    _c(
                      "div",
                      { staticClass: "form-group mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Nombre de la Empresa"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.company,
                              expression: "data.company",
                            },
                          ],
                          staticClass: "form-control",
                          class: _vm.errors.company ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.company },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.data, "company", $event.target.value)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.company, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.data.account_type != 2
                ? _c("div", { staticClass: "col-lg-6 px-0 pl-lg-0 pr-lg-2" }, [
                    _c(
                      "div",
                      { staticClass: "form-group mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Nombre"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.first_name,
                              expression: "data.first_name",
                            },
                          ],
                          staticClass: "form-control",
                          class: _vm.errors.first_name ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.first_name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "first_name",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.first_name, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.data.account_type != 2
                ? _c("div", { staticClass: "col-lg-6 px-0 pr-lg-0 pl-lg-2" }, [
                    _c(
                      "div",
                      { staticClass: "form-group mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Apellido"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.last_name,
                              expression: "data.last_name",
                            },
                          ],
                          staticClass: "form-control",
                          class: _vm.errors.last_name ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.last_name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "last_name",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.last_name, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6 px-0 pl-lg-0 pr-lg-2" }, [
                _c(
                  "div",
                  { staticClass: "form-group mb-2" },
                  [
                    _c("small", { staticClass: "input-title" }, [
                      _vm._v("Tipo de cuenta"),
                    ]),
                    _vm._v(" "),
                    _c("v-select", {
                      staticClass: "form-control",
                      class: _vm.errors.account_type ? "is-invalid" : "",
                      attrs: {
                        items: _vm.accounts.filter(function (e) {
                          return e.value != 0
                        }),
                        "hide-details": "",
                      },
                      on: { change: _vm.CHANGE },
                      model: {
                        value: _vm.data.account_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "account_type", $$v)
                        },
                        expression: "data.account_type",
                      },
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.errors.account_type, function (error, index) {
                      return _c(
                        "small",
                        { key: index, staticClass: "invalid-feedback" },
                        [_vm._v(_vm._s(error))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6 px-0 pr-lg-0 pl-lg-2" }, [
                _c(
                  "div",
                  { staticClass: "form-group mb-2" },
                  [
                    _c("small", { staticClass: "input-title" }, [
                      _vm._v("Genero"),
                    ]),
                    _vm._v(" "),
                    _c("v-select", {
                      staticClass: "form-control",
                      class: _vm.errors.gender ? "is-invalid" : "",
                      attrs: { items: _vm.genders, "hide-details": "" },
                      model: {
                        value: _vm.data.gender,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "gender", $$v)
                        },
                        expression: "data.gender",
                      },
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.errors.gender, function (error, index) {
                      return _c(
                        "small",
                        { key: index, staticClass: "invalid-feedback" },
                        [_vm._v(_vm._s(error))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-12 px-0" }, [
                _c(
                  "div",
                  { staticClass: "form-group mb-2" },
                  [
                    _c("small", { staticClass: "input-title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.data.account_type != 2
                            ? "Identificación"
                            : "Cédula Jurídica"
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: _vm.format,
                          expression: "format",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.identification,
                          expression: "data.identification",
                        },
                      ],
                      staticClass: "form-control",
                      class: _vm.errors.identification ? "is-invalid" : "",
                      attrs: { type: "text" },
                      domProps: { value: _vm.data.identification },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.data,
                            "identification",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.errors.identification, function (error, index) {
                      return _c(
                        "small",
                        { key: index, staticClass: "invalid-feedback" },
                        [_vm._v(_vm._s(error))]
                      )
                    }),
                    _vm._v(" "),
                    _vm.data.account_type == 2
                      ? _c("small", [
                          _vm._v(
                            "Ejemplo: Si es 3-101-123456 se debe digitar 3101123456"
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
            ])
          : _vm.step == 2
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-6 px-0 pl-lg-0 pr-lg-2" }, [
                _c(
                  "div",
                  { staticClass: "form-group mb-2" },
                  [
                    _c("small", { staticClass: "input-title" }, [
                      _vm._v("Tel. Casa: "),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.phone,
                          expression: "data.phone",
                        },
                      ],
                      staticClass: "form-control form-control-sm",
                      class: _vm.errors.phone ? "is-invalid" : "",
                      attrs: { type: "text" },
                      domProps: { value: _vm.data.phone },
                      on: {
                        keypress: _vm.NUMBER,
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.data, "phone", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.errors.phone, function (error, index) {
                      return _c(
                        "small",
                        { key: index, staticClass: "invalid-feedback" },
                        [_vm._v(_vm._s(error))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6 px-0 pr-lg-0 pl-lg-2" }, [
                _c(
                  "div",
                  { staticClass: "form-group mb-2" },
                  [
                    _c("small", { staticClass: "input-title" }, [
                      _vm._v("Tel. Celular: "),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.mobil,
                          expression: "data.mobil",
                        },
                      ],
                      staticClass: "form-control form-control-sm",
                      class: _vm.errors.mobil ? "is-invalid" : "",
                      attrs: { type: "text" },
                      domProps: { value: _vm.data.mobil },
                      on: {
                        keypress: _vm.NUMBER,
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.data, "mobil", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.errors.mobil, function (error, index) {
                      return _c(
                        "small",
                        { key: index, staticClass: "invalid-feedback" },
                        [_vm._v(_vm._s(error))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6 px-0 pl-lg-0 pr-lg-2" }, [
                _c("div", { staticClass: "d-flex" }, [
                  _c("div", { staticClass: "w-75" }, [
                    _c(
                      "div",
                      { staticClass: "form-group mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Tel. Trabajo: "),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.phone_work,
                              expression: "data.phone_work",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.phone_work ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.phone_work },
                          on: {
                            keypress: _vm.NUMBER,
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "phone_work",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.phone_work, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "w-25 pl-2" }, [
                    _c(
                      "div",
                      { staticClass: "form-group mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Ext.: "),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.phone_work_ext,
                              expression: "data.phone_work_ext",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.phone_work_ext ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.phone_work_ext },
                          on: {
                            keypress: _vm.NUMBER,
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "phone_work_ext",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(
                          _vm.errors.phone_work_ext,
                          function (error, index) {
                            return _c(
                              "small",
                              { key: index, staticClass: "invalid-feedback" },
                              [_vm._v(_vm._s(error))]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6 px-0 pr-lg-0 pl-lg-2" }, [
                _c(
                  "div",
                  { staticClass: "form-group mb-2" },
                  [
                    _c("small", { staticClass: "input-title" }, [
                      _vm._v("Otro: "),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.phone_other,
                          expression: "data.phone_other",
                        },
                      ],
                      staticClass: "form-control form-control-sm",
                      class: _vm.errors.phone_other ? "is-invalid" : "",
                      attrs: { type: "text" },
                      domProps: { value: _vm.data.phone_other },
                      on: {
                        keypress: _vm.NUMBER,
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.data, "phone_other", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.errors.phone_other, function (error, index) {
                      return _c(
                        "small",
                        { key: index, staticClass: "invalid-feedback" },
                        [_vm._v(_vm._s(error))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ])
          : _vm.step == 3
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-6 px-0 pl-lg-0 pr-lg-2" }, [
                _c(
                  "div",
                  { staticClass: "form-group mb-2" },
                  [
                    _c("small", { staticClass: "input-title" }, [
                      _vm._v("Entregar en: "),
                    ]),
                    _vm._v(" "),
                    _c("v-select", {
                      staticClass: "form-control form-control-sm",
                      class: _vm.errors.branch ? "is-invalid" : "",
                      attrs: { items: _vm.delivers, "hide-details": "" },
                      on: { change: _vm.FRESH },
                      model: {
                        value: _vm.data.deliver_to,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "deliver_to", $$v)
                        },
                        expression: "data.deliver_to",
                      },
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.errors.deliver_to, function (error, index) {
                      return _c(
                        "small",
                        { key: index, staticClass: "invalid-feedback" },
                        [_vm._v(_vm._s(error))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _vm.data.deliver_to == 1
                ? _c("div", { staticClass: "col-lg-6 px-0 pr-lg-0 pl-lg-2" }, [
                    _c(
                      "div",
                      { staticClass: "form-group mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Sucursal: "),
                        ]),
                        _vm._v(" "),
                        _c("v-select", {
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.branch_office_id
                            ? "is-invalid"
                            : "",
                          attrs: {
                            "item-value": "id",
                            "item-text": "name",
                            items: _vm.branch_offices.filter(function (e) {
                              return e.id == 1
                            }),
                            "hide-details": "",
                          },
                          model: {
                            value: _vm.data.branch_office_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "branch_office_id", $$v)
                            },
                            expression: "data.branch_office_id",
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(
                          _vm.errors.branch_office_id,
                          function (error, index) {
                            return _c(
                              "small",
                              { key: index, staticClass: "invalid-feedback" },
                              [_vm._v(_vm._s(error))]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                  ])
                : _c("div", { staticClass: "col-lg-6 px-0 pr-lg-0 pl-lg-2" }, [
                    _c(
                      "div",
                      { staticClass: "form-group mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Dirección: "),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.address,
                              expression: "data.address",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.address ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.address },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.data, "address", $event.target.value)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.address, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
              _vm._v(" "),
              _vm.data.deliver_to == 0
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-3 px-0 pl-lg-0 pr-lg-2" },
                      [
                        _c(
                          "div",
                          { staticClass: "form-group mb-2" },
                          [
                            _c("small", { staticClass: "input-title" }, [
                              _vm._v("País: "),
                            ]),
                            _vm._v(" "),
                            _c("v-select", {
                              staticClass: "form-control form-control-sm",
                              class: _vm.errors.country_id ? "is-invalid" : "",
                              attrs: {
                                items: _vm.countries,
                                "item-text": "name",
                                "item-value": "id",
                                "hide-details": "",
                              },
                              on: { change: _vm.PROVINCES },
                              model: {
                                value: _vm.data.country_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.data, "country_id", $$v)
                                },
                                expression: "data.country_id",
                              },
                            }),
                            _vm._v(" "),
                            _vm._l(
                              _vm.errors.country_id,
                              function (error, index) {
                                return _c(
                                  "small",
                                  {
                                    key: index,
                                    staticClass: "invalid-feedback",
                                  },
                                  [_vm._v(_vm._s(error))]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 px-0 pl-lg-0 pr-lg-2" },
                      [
                        _c(
                          "div",
                          { staticClass: "form-group mb-2" },
                          [
                            _c("small", { staticClass: "input-title" }, [
                              _vm._v("Provincia: "),
                            ]),
                            _vm._v(" "),
                            _c("v-select", {
                              staticClass: "form-control form-control-sm",
                              class: _vm.errors.province_id ? "is-invalid" : "",
                              attrs: {
                                items: _vm.provinces,
                                "item-text": "name",
                                "item-value": "id",
                                "hide-details": "",
                              },
                              on: { change: _vm.CITIES },
                              model: {
                                value: _vm.data.province_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.data, "province_id", $$v)
                                },
                                expression: "data.province_id",
                              },
                            }),
                            _vm._v(" "),
                            _vm._l(
                              _vm.errors.province_id,
                              function (error, index) {
                                return _c(
                                  "small",
                                  {
                                    key: index,
                                    staticClass: "invalid-feedback",
                                  },
                                  [_vm._v(_vm._s(error))]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 px-0 pl-lg-0 pr-lg-2" },
                      [
                        _c(
                          "div",
                          { staticClass: "form-group mb-2" },
                          [
                            _c("small", { staticClass: "input-title" }, [
                              _vm._v("Cuidad: "),
                            ]),
                            _vm._v(" "),
                            _c("v-select", {
                              staticClass: "form-control form-control-sm",
                              class: _vm.errors.city_id ? "is-invalid" : "",
                              attrs: {
                                items: _vm.cities,
                                "item-text": "name",
                                "item-value": "id",
                                "hide-details": "",
                              },
                              on: { change: _vm.DISTRICTS },
                              model: {
                                value: _vm.data.city_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.data, "city_id", $$v)
                                },
                                expression: "data.city_id",
                              },
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.errors.city_id, function (error, index) {
                              return _c(
                                "small",
                                { key: index, staticClass: "invalid-feedback" },
                                [_vm._v(_vm._s(error))]
                              )
                            }),
                          ],
                          2
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 px-0 pr-lg-0 pl-lg-2" },
                      [
                        _c(
                          "div",
                          { staticClass: "form-group mb-2" },
                          [
                            _c("small", { staticClass: "input-title" }, [
                              _vm._v("Distrito: "),
                            ]),
                            _vm._v(" "),
                            _c("v-select", {
                              staticClass: "form-control form-control-sm",
                              class: _vm.errors.district_id ? "is-invalid" : "",
                              attrs: {
                                items: _vm.districts,
                                "item-text": "name",
                                "item-value": "id",
                                "hide-details": "",
                              },
                              model: {
                                value: _vm.data.district_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.data, "district_id", $$v)
                                },
                                expression: "data.district_id",
                              },
                            }),
                            _vm._v(" "),
                            _vm._l(
                              _vm.errors.district_id,
                              function (error, index) {
                                return _c(
                                  "small",
                                  {
                                    key: index,
                                    staticClass: "invalid-feedback",
                                  },
                                  [_vm._v(_vm._s(error))]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-group mt-1",
            class: _vm.step > 1 ? "d-flex gap-2" : "d-block",
          },
          [
            _vm.step > 1
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-dark btn-x mb-2",
                    class: _vm.step > 1 ? "w-50" : "w-100",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.LAST()
                      },
                    },
                  },
                  [_c("span", [_vm._v("Anterior")])]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-x",
                class: _vm.step > 1 ? "w-50" : "w-100",
                attrs: { type: "submit" },
              },
              [
                _vm.count == 1
                  ? _c(
                      "div",
                      {
                        staticClass: "spinner-border spinner-border-sm",
                        attrs: { role: "status" },
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Loading..."),
                        ]),
                      ]
                    )
                  : _c("span", [
                      _vm._v(_vm._s(_vm.step == 3 ? "Completar" : "Siguiente")),
                    ]),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }